import BaseService from './Base';
import ConfigService from './Config';

class ChargeCodes extends BaseService {
  static endpoint = 'api/2.0/charge-codes/';
}

export default ChargeCodes;